<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-user-plus"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ isEditMode ? 'แก้ไขกลุ่มอนุมัติ' : 'สร้างกลุ่มอนุมัติใหม่' }}
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <router-link
              :to="'/BudgetPlan/ApproveGroup'"
              class="btn btn-secondary"
            >
              <i class="la la-close"></i> ย้อนกลับ
            </router-link>
          </div>
        </div>
        <div class="kt-portlet__body">
          <form class="kt-form" @submit.prevent="submitForm" ref="mainForm">
            <!-- ข้อมูลพื้นฐาน -->
            <div class="kt-section kt-section--first">
              <h3 class="kt-section__title">ชื่อกลุ่ม :</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <input
                        v-model="formData.groupName"
                        type="text"
                        class="form-control"
                        placeholder="พิมพ์ชื่อกลุ่มอนุมัติ"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                    <div class="form-group">
                      <div class="kt-radio-inline">
                        <label class="kt-radio">
                          <input
                            type="radio"
                            v-model="formData.isActive"
                            :value="true"
                          />
                          ใช้งาน
                          <span></span>
                        </label>
                        <label class="kt-radio">
                          <input
                            type="radio"
                            v-model="formData.isActive"
                            :value="false"
                          />
                          ไม่ใช้งาน
                          <span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- แผนก -->
            <div class="kt-section">
              <h3 class="kt-section__title">แผนก :</h3>
              <div class="kt-section__body">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered table-hover">
                    <thead>
                      <tr class="text-center">
                        <th style="width: 5%;">ลำดับ</th>
                        <th style="width: 80%;">แผนก</th>
                        <th style="width: 15%;">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="formData.orgs.length === 0">
                        <td colspan="3" class="text-center text-muted">
                          <i class="fas fa-info-circle"></i> ยังไม่มีข้อมูลแผนก กรุณาเพิ่มแผนก
                        </td>
                      </tr>
                      <tr v-for="(org, index) in formData.orgs" :key="'org-' + org._uid">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control'"
                            :id="'org_' + index"
                            :name="'org_' + index"
                            :select2-options="orgOptions"
                            v-model="org.orgId"
                            :ref="'orgSelect_' + index"
                            :required="true"
                            @input="onOrgSelected($event, index)"
                          ></select2>
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon"
                            @click="removeOrg(index)"
                            title="ลบ"
                          >
                            <i class="la la-trash text-secondary"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-3">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addOrg"
                  >
                    <i class="fas fa-plus"></i> เพิ่มรายการใหม่
                  </button>
                </div>
              </div>
            </div>

            <!-- ลำดับการอนุมัติ -->
            <div class="kt-section">
              <h3 class="kt-section__title">ลำดับการอนุมัติ :</h3>
              <div class="kt-section__body">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered table-hover table-approvers">
                    <thead>
                      <tr class="text-center">
                        <th style="width: 5%;">ลำดับ</th>
                        <th style="width: 40%;">ชื่อพนักงาน</th>
                        <th style="width: 10%;">ลำดับอนุมัติ</th>
                        <th style="width: 12%;">ประเภท</th>
                        <th style="width: 15%;">รูปแบบอีเมลแจ้งเตือน</th>
                        <th style="width: 15%;">บันทึกลายเซ็นอนุมัติ</th>
                        <th style="width: 8%;">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="formData.approvers.length === 0">
                        <td colspan="7" class="text-center text-muted">
                          <i class="fas fa-info-circle"></i> ยังไม่มีข้อมูลผู้อนุมัติ กรุณาเพิ่มผู้อนุมัติ
                        </td>
                      </tr>
                      <tr v-for="(approver, index) in formData.approvers" :key="'approver-' + approver._uid">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control'"
                            :id="'approver_' + index"
                            :name="'approver_' + index"
                            :select2-options="approverOptions"
                            v-model="approver.userId"
                            :ref="'approverSelect_' + index"
                            :required="true"
                          ></select2>
                        </td>
                        <td class="text-center">
                          ลำดับ {{ approver.approvalLevel }}
                        </td>
                        <td class="text-center">
                          <select
                            v-model="approver.approverType"
                            class="form-control form-control-sm"
                            @change="onApproverTypeChanged(index)"
                          >
                            <option value="APPROVE">ผู้อนุมัติ</option>
                            <option value="CONFIRM">ผู้ยืนยัน</option>
                          </select>
                        </td>
                        <td class="text-center">
                          <select
                            v-model="approver.emailNotificationType"
                            class="form-control form-control-sm"
                          >
                            <option value="SEPARATE">แยกใบงาน</option>
                            <option value="COMBINED">รวมใบงาน</option>
                          </select>
                        </td>
                        <td class="text-center">
                          <label v-if="approver.approverType === 'APPROVE'" class="kt-radio kt-radio--sm" style="margin-bottom: 0;">
                            <input
                              type="radio"
                              name="signatureRequired"
                              :value="index"
                              :checked="approver.isSignatureRequired === true"
                              @change="onSignatureChanged(index, true)"
                            />
                            บันทึก
                            <span></span>
                          </label>
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon"
                            @click="removeApprover(index)"
                            title="ลบ"
                          >
                            <i class="la la-trash text-secondary"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="formData.approvers.length >= 5" class="alert alert-warning mt-3">
                  <i class="fas fa-exclamation-triangle"></i>
                  สามารถเพิ่มผู้อนุมัติได้สูงสุด 5 ระดับเท่านั้น
                </div>
                <div class="mt-3">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addApprover"
                    :disabled="formData.approvers.length >= 5"
                  >
                    <i class="fas fa-plus"></i> เพิ่มรายการใหม่
                  </button>
                </div>
              </div>
            </div>

            <!-- Buttons -->
            <div class="kt-section">
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-lg-12">
                    <router-link
                      :to="'/BudgetPlan/ApproveGroup'"
                      class="btn btn-secondary"
                    >
                      <i class="la la-close"></i> ย้อนกลับ
                    </router-link>
                    <button type="submit" class="btn btn-primary">
                      <i class="la la-save"></i> บันทึก
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";

require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function () {
    let self = this;
    return {
      isEditMode: false,
      approveGroupId: null,
      isDataLoaded: false, // Add flag to control rendering
      isValidating: false, // Flag to prevent recursive validation
      uidCounter: 0, // Counter for unique IDs
      formData: {
        groupName: "",
        isActive: true,
        orgs: [],
        approvers: [],
      },
      orgOptions: {
        placeholder: "กรุณาเลือกแผนก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterOrg/Select2Org",
          type: "get",
          delay: 300,
          dataType: "json",
          data: function (params) {
            return {
              search: params.term,
              page: params.page || 1,
            };
          },
          processResults: function (data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function (params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      approverOptions: {
        placeholder: "กรุณาเลือกพนักงาน",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2UserForBudgetApprovers",
          type: "get",
          delay: 300,
          dataType: "json",
          data: function (params) {
            return {
              search: params.term,
              page: params.page || 1,
            };
          },
          processResults: function (data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function (params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onOrgSelected: function (selectedOrgId, currentIndex) {
      let self = this;
      
      if (!selectedOrgId) return;
      
      // Prevent recursive validation
      if (self.isValidating) return;

      // Check duplicate within the same group
      const duplicateIndex = self.formData.orgs.findIndex((org, idx) => 
        idx !== currentIndex && org.orgId === selectedOrgId
      );

      if (duplicateIndex !== -1) {
        self.isValidating = true;
        Swal.fire({
          title: "แจ้งเตือน",
          text: "แผนกนี้ถูกเลือกไว้แล้วในกลุ่มนี้ กรุณาเลือกแผนกอื่น",
          type: "warning",
          confirmButtonText: "ตกลง"
        }).then(() => {
          // Clear the selection
          self.formData.orgs[currentIndex].orgId = "";
          if (self.$refs['orgSelect_' + currentIndex] && self.$refs['orgSelect_' + currentIndex][0]) {
            self.$refs['orgSelect_' + currentIndex][0].clearData();
          }
          self.isValidating = false;
        });
        return;
      }

      // Check if org is used in another group
      self.isValidating = true;
      axios
        .get("/Api/BudgetPlan/ApproveGroup/CheckOrgUsage", {
          params: {
            orgId: selectedOrgId,
            currentGroupId: self.approveGroupId || 0
          },
          headers: {
            Authorization: "Bearer " + self.$root.user.access_token,
          },
        })
        .then(function (response) {
          if (response.data && response.data.isUsed) {
            Swal.fire({
              title: "แจ้งเตือน",
              html: `แผนก '<strong>${response.data.orgName}</strong>' ถูกใช้ในกลุ่ม '<strong>${response.data.groupName}</strong>' อยู่แล้ว<br>ไม่สามารถเพิ่มซ้ำได้`,
              type: "warning",
              confirmButtonText: "ตกลง"
            }).then(() => {
              // Clear the selection
              self.formData.orgs[currentIndex].orgId = "";
              if (self.$refs['orgSelect_' + currentIndex] && self.$refs['orgSelect_' + currentIndex][0]) {
                self.$refs['orgSelect_' + currentIndex][0].clearData();
              }
              self.isValidating = false;
            });
          } else {
            // No error, clear validation flag
            self.isValidating = false;
          }
        })
        .catch(function (error) {
          console.error("Error checking org usage:", error);
          self.isValidating = false;
        });
    },
    addOrg: function () {
      this.formData.orgs.push({
        _uid: ++this.uidCounter,
        orgId: "",
      });
    },
    removeOrg: function (index) {
      this.formData.orgs.splice(index, 1);
    },
    addApprover: function () {
      if (this.formData.approvers.length >= 5) {
        Swal.fire({
          title: "แจ้งเตือน",
          text: "สามารถเพิ่มผู้อนุมัติได้สูงสุด 5 ระดับเท่านั้น",
          type: "warning",
        });
        return;
      }
      // Auto assign approval level based on current count
      const nextLevel = this.formData.approvers.length + 1;
      this.formData.approvers.push({
        _uid: ++this.uidCounter,
        userId: "",
        approvalLevel: nextLevel,
        approverType: "APPROVE", // Default to APPROVE
        isSignatureRequired: false, // Default to ไม่บันทึก
        emailNotificationType: "SEPARATE", // FR-011: Default to แยกใบงาน
      });
    },
    removeApprover: function (index) {
      this.formData.approvers.splice(index, 1);
      // Reassign approval levels after removal (keep approverType)
      this.formData.approvers.forEach((approver, idx) => {
        approver.approvalLevel = idx + 1;
      });
    },
    onApproverTypeChanged: function (index) {
      // When type changes to CONFIRM, auto-set isSignatureRequired to false
      if (this.formData.approvers[index].approverType === "CONFIRM") {
        Vue.set(this.formData.approvers[index], "isSignatureRequired", false);
      }
    },
    onSignatureChanged: function (index, value) {
      if (value) {
        // Only 1 row per group can have "บันทึก" — auto-set others to "ไม่บันทึก"
        this.formData.approvers.forEach((approver, idx) => {
          Vue.set(approver, "isSignatureRequired", idx === index);
        });
      } else {
        Vue.set(this.formData.approvers[index], "isSignatureRequired", false);
      }
    },
    loadApproveGroupData: function () {
      let self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios
        .get("/Api/BudgetPlan/ApproveGroup/" + self.approveGroupId, {
          headers: {
            Authorization: "Bearer " + self.$root.user.access_token,
          },
        })
        .then(function (response) {
          console.log("API Response:", response.data);
          
          // Support both formats: {data: {...}} and direct object
          let data = response.data.data || response.data;
          
          if (data && data.groupName) {
            console.log("Loaded data:", data);
            
            self.formData.groupName = data.groupName;
            self.formData.isActive = data.isActive;
            
            // Load orgs with formatted text for Select2 [Code] Name
            self.formData.orgs = (data.orgs || []).map(org => ({
              _uid: ++self.uidCounter,
              orgId: org.orgId,
              orgText: `[${org.orgCode}] ${org.orgName}` // Format: [Code] Name
            }));

            // Load approvers with formatted text for Select2 [Email] Full Name
            self.formData.approvers = (data.approvers || []).map(approver => ({
              _uid: ++self.uidCounter,
              userId: approver.userId,
              approvalLevel: approver.approvalLevel,
              approverType: approver.approverType || "APPROVE",
              isSignatureRequired: approver.isSignatureRequired || false,
              emailNotificationType: approver.emailNotificationType || "SEPARATE", // FR-011
              userText: `[${approver.userEmail}] ${approver.userName}` // Format: [Email] Full Name
            }));

            console.log("FormData after load:", self.formData);

            // Set flag to trigger rendering
            self.isDataLoaded = true;

            // Initialize Select2 with loaded data after Vue renders
            self.$nextTick(() => {
              // Wait for DOM to be ready
              setTimeout(() => {
                console.log("Initializing Select2...");
                console.log("Refs available:", Object.keys(self.$refs));
                
                // Initialize org Select2 with loaded data
                self.formData.orgs.forEach((org, index) => {
                  let refName = 'orgSelect_' + index;
                  console.log("Looking for ref:", refName);
                  
                  if (self.$refs[refName] && self.$refs[refName][0]) {
                    let select2Component = self.$refs[refName][0];
                    console.log("Found org select2 component");
                    
                    // Use setSelectedData method
                    select2Component.setSelectedData({
                      id: org.orgId,
                      text: org.orgText
                    });
                    console.log("Set org data:", org.orgText, org.orgId);
                  } else {
                    console.log("Ref not found:", refName);
                  }
                });

                // Initialize approver Select2 with loaded data
                self.formData.approvers.forEach((approver, index) => {
                  let refName = 'approverSelect_' + index;
                  console.log("Looking for ref:", refName);
                  
                  if (self.$refs[refName] && self.$refs[refName][0]) {
                    let select2Component = self.$refs[refName][0];
                    console.log("Found approver select2 component");
                    
                    // Use setSelectedData method
                    select2Component.setSelectedData({
                      id: approver.userId,
                      text: approver.userText
                    });
                    console.log("Set approver data:", approver.userText, approver.userId);
                  } else {
                    console.log("Ref not found:", refName);
                  }
                });
              }, 200); // Increase timeout to 200ms
            });
          } else {
            console.log("No data in response");
          }
        })
        .catch(function (error) {
          console.error("Error loading approve group:", error);
          Swal.fire("ผิดพลาด", "ไม่สามารถโหลดข้อมูลกลุ่มอนุมัติได้", "error").then(
            function () {
              router.push({ path: "/BudgetPlan/ApproveGroup" });
            }
          );
        })
        .finally(function () {
          KTApp.unblockPage();
        });
    },
    validateForm: function () {
      if (!this.formData.groupName || this.formData.groupName.trim() === "") {
        Swal.fire("แจ้งเตือน", "กรุณากรอกชื่อกลุ่มอนุมัติ", "warning");
        return false;
      }

      if (this.formData.orgs.length === 0) {
        Swal.fire("แจ้งเตือน", "กรุณาเพิ่มแผนกอย่างน้อย 1 แผนก", "warning");
        return false;
      }

      // Check duplicate orgs
      let orgIds = this.formData.orgs.map((o) => o.orgId);
      let uniqueOrgIds = [...new Set(orgIds)];
      if (orgIds.length !== uniqueOrgIds.length) {
        Swal.fire("แจ้งเตือน", "มีแผนกซ้ำกัน กรุณาตรวจสอบ", "warning");
        return false;
      }

      // Check empty org
      if (orgIds.some((id) => !id || id === "")) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกแผนกให้ครบถ้วน", "warning");
        return false;
      }

      if (this.formData.approvers.length === 0) {
        Swal.fire("แจ้งเตือน", "กรุณาเพิ่มผู้อนุมัติอย่างน้อย 1 คน", "warning");
        return false;
      }

      // Check empty approver
      if (this.formData.approvers.some((approver) => !approver.userId || approver.userId === "")) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกผู้อนุมัติให้ครบถ้วน", "warning");
        return false;
      }

      return true;
    },
    submitForm: function () {
      let self = this;

      if (!self.validateForm()) {
        return;
      }

      Swal.fire({
        title: "ยืนยันการบันทึก",
        text: "คุณต้องการบันทึกข้อมูลกลุ่มอนุมัตินี้หรือไม่?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });

          let payload = {
            id: self.approveGroupId || 0,
            groupName: self.formData.groupName,
            isActive: self.formData.isActive,
            orgs: self.formData.orgs.map(o => ({ orgId: o.orgId })),
            approvers: self.formData.approvers.map(a => ({
              userId: a.userId,
              approvalLevel: a.approvalLevel,
              approverType: a.approverType || "APPROVE",
              isSignatureRequired: a.approverType === "APPROVE" ? (a.isSignatureRequired || false) : false,
              emailNotificationType: a.emailNotificationType || "SEPARATE" // FR-011
            })),
          };

          axios
            .post("/Api/BudgetPlan/ApproveGroup/Save", payload, {
              headers: {
                Authorization: "Bearer " + self.$root.user.access_token,
              },
            })
            .then(function (response) {
              if (response.data && response.data.success) {
                Swal.fire("สำเร็จ", response.data.message, "success").then(
                  function () {
                    // Navigate back and trigger reload
                    router.push({ 
                      path: "/BudgetPlan/ApproveGroup",
                      query: { reload: Date.now() }
                    });
                  }
                );
              } else {
                Swal.fire("ผลลัพธ์", response.data.message || "เกิดข้อผิดพลาด", "warning");
              }
            })
            .catch(function (error) {
              console.error("Save error:", error);
              let errorMessage = "เกิดข้อผิดพลาดในการบันทึกข้อมูล";
              if (
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                errorMessage = error.response.data.message;
              } else if (error.response && error.response.data) {
                console.error("Full error response:", error.response.data);
                errorMessage = JSON.stringify(error.response.data);
              }
              Swal.fire("ผิดพลาด", errorMessage, "error");
            })
            .finally(function () {
              KTApp.unblockPage();
            });
        }
      });
    },
  },
  mounted() {
    // Check if edit mode
    if (this.$route.params.id) {
      this.isEditMode = true;
      this.approveGroupId = parseInt(this.$route.params.id);
      this.loadApproveGroupData();
    } else {
      // Create mode - set flag immediately
      this.isDataLoaded = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.table-approvers td {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/ApproveGroupForm.vue